import type { ComponentProps, ReactNode } from 'react'

const fieldClassName = "block shadow rounded-md border border-gray-400 outline-none px-3 py-2 mt-2 w-full"
const errorClassName = "text-red-500 px-3 py-2 font-medium"

type FieldError = string[] | undefined

interface TextFieldProps extends Pick<ComponentProps<'input'>, 'defaultValue' | 'id' | 'name'> {
  label: ReactNode
  error: FieldError
}

export function TextField({ label, error, ...inputProps }: TextFieldProps) {
  return (
    <div className="my-5">
      <label htmlFor={inputProps.id}>{label}</label>
      <input
        type="text"
        className={fieldClassName}
        {...inputProps}
      />
      {error && (
        <div className={errorClassName}>
          {error.join(', ')}
        </div>
      )}
    </div>
  )
}

interface SelectOption {
  id: string
  name: string
  code: string
}

interface SelectFieldProps extends Pick<ComponentProps<'select'>, 'defaultValue' | 'disabled' | 'id' | 'name' | 'onChange' | 'value'> {
  label: ReactNode
  placeholder: string
  options: SelectOption[]
  error: FieldError
}

export function SelectField({ label, placeholder, options, error, ...selectProps }: SelectFieldProps) {
  return (
    <div className="my-5">
      <label htmlFor={selectProps.id}>{label}</label>
      <select
        className={fieldClassName}
        required
        {...selectProps}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name} ({option.code})
          </option>
        ))}
      </select>
      {error && (
        <div className={errorClassName}>
          {error.join(', ')}
        </div>
      )}
    </div>
  )
}
